/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
/*
  This HelpText component is used to show tooltip at any component or page
  longText  : This can be any html string or text content which will be parsed and shown as tooltip when hover on help icon
*/
import React from 'react'
import InfoIcon from '@mui/icons-material/Info'
import parse from 'html-react-parser'
import Tooltip from '@mui/material/Tooltip'
import PropTypes from 'prop-types'

import './InfoText.css'

function InfoText({ longText = '' }) {
  // parse and renders infoText only if there is infoText content to show
  return longText ? (
    <div className="infoTextIcon">
      <Tooltip
        title={
          longText && (
            <div data-testid="LongText" className="LongText">
              {parse(longText)}
            </div>
          )
        }
        arrow
        placement="right"
      >
        <InfoIcon className="tooltip" data-testid="OpenButton" />
      </Tooltip>
    </div>
  ) : null
}

InfoText.defaultProps = {
  longText: '',
}
InfoText.propTypes = {
  longText: PropTypes.string,
}

export default InfoText
